import request from '../index';
import qs from 'qs';

// 更新使用状态
export const updateserial = (data) => request.put('api-qc/serial/update', data);

// 导出设备机身号
export const exportSerial = (data) => request.post('api-qc/serial/exportSerial', data, { responseType: 'blob' });

// 删除
export const deleteserial = (data) => request.delete('/api-qc/serial/delete', { data });

// 设备随机序列号
export const randomSerial = (data) => request.get(`/api-qc/serial/randomSerial?${qs.stringify(data)}`);

// 获取设备序列号列表
export const getSerialList = (data) => request.get(`/api-qc/serial/getSerialList?${qs.stringify(data)}`);
